<div class="content-container">
  <div class="container-grid">
    <div fxLayout="column" [ngClass]="{ off: getProcessStatus() == 1 || getProcessStatus() == 2 }" fxLayoutGap="10px">
      <div fxLayout="row" class="container-button" fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="hasCompany()">
        <div class="company-logo">
          <img src="./assets/icons/no-logo-company-icon.svg" />
        </div>

        <div class="company-data" fxLayout="column" fxLayoutGap="10px">
          <span class="company-name">{{ getCompany().getCorporateName() }} </span>
          <span class="company-cnpj"> <b>CNPJ: </b>{{ getCompany().getFiscalNumber() | companyFederalNumber }} </span>
        </div>
      </div>
      <form [formGroup]="getFilters()" fxLayout="column" fxLayoutGap="10px" >
        <mat-card class="card-form">
          <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
            <div fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayoutGap="10px">

                <mat-form-field>
                  <mat-label>Cartão</mat-label>
                  <mat-select formControlName="cardState" multiple>
                      <mat-option [value]="0">Ativo</mat-option>
                      <mat-option [value]="1">Bloqueado</mat-option>
                      <mat-option [value]="2">Cancelado</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Titular/Dependente</mat-label>
                  <mat-select required formControlName="typeExport">
                    <mat-option [value]="0">Todos</mat-option>
                    <mat-option [value]="1">Somente Titular</mat-option>
                    <mat-option [value]="2">Somente Dependente</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
                <mat-form-field class="date-field">
                  <mat-label>Data Inicial de Cadastro</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="startDate"
                    placeholder="00/00/0000"
                    [textMask]="{ mask: dateMask, guide: false, keepCharPositions: true }" />
                </mat-form-field>

                <mat-form-field class="date-field">
                  <mat-label>Data Final de Cadastro</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="endDate"
                    placeholder="00/00/0000"
                    [textMask]="{ mask: dateMask, guide: false, keepCharPositions: true }" />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
              <button mat-flat-button *ngIf="getShowClearButtom()" class="clear-button" (click)="clearFields()">
                <mat-icon aria-hidden="false">filter_alt_off</mat-icon>
                Limpar campos
              </button>
              <button mat-flat-button class="filter-button" color="accent" (click)="filterBenefiaries()">Filtrar</button>
            </div>
          </div>
        </mat-card>
        <mat-card class="container-button" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" *ngIf="getAllowedBeneficiries().data.length > 0">
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-radio-group class="report-option" aria-label="Select an option" formControlName="format" fxLayoutGap="10px">
              <mat-radio-button value="xlsx">XLSX</mat-radio-button>
              <mat-radio-button value="csv">CSV</mat-radio-button>
            </mat-radio-group>
            <button
              class="download-button"
              mat-flat-button
              color="accent"
              (click)="doActionReport()"
              [disabled]="getProcessStatus() == 1"
              [ngStyle]="getProcessStyle()">
              <mat-icon *ngIf="getProcessStatus() != 0">{{ getProcessStatus() == 2 ? "check" : "hourglass_full" }}</mat-icon>
              {{ getProcessStatus() == 0 ? "PROCESSAR RELATÓRIO" : getProcessStatus() == 1 ? "RELATÓRIO EM PROCESSAMENTO..." : "RELATÓRIO FINALIZADO" }}
            </button>
            <small> Download automático </small>
          </div>
          <div fxLayout="column" fxLayoutGap="10px">
            <p *ngIf="hasSelectedBeneficiries()">
              <small> *Somente os itens selecionados aparecem no relatório </small>
            </p>
          </div>
        </mat-card>
      </form>
      <div class="benecifiaries-list-container">
        <table mat-table [dataSource]="getAllowedBeneficiries()" class="mat-elevation-z8">
          <ng-container matColumnDef="check">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="getSelectedBeneficiries().selected.length > 0 && isAllSelected()">
              </mat-checkbox>
            </th>

            <td mat-cell *matCellDef="let element">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="selectBeneficiary($event, element)" [checked]="getIsSelected(element) !== -1">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dataCadastro">
            <th mat-header-cell *matHeaderCellDef>Data Cad.</th>
            <td mat-cell *matCellDef="let element">
              {{ element.ActivationDate | date : "dd/MM/yyyy - HH:mm" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dependent">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Dependent ? "Dependente" : "Titular" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Active ? "Ativado" : "Desativado" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totalSelected">
            <th mat-header-cell *matHeaderCellDef>[ {{ getSelectedDescription() }} ]</th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns; let even = even" [ngClass]="{ gray: even }"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="totalPerPagesOptions" [length]="count" showFirstLastButtons class="mat-elevation-z8"> </mat-paginator>
      </div>
    </div>
  </div>
</div>
